var render = function render() {
  var _vm$item;
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "micro-feed"
  }, [_vm.visibleIframe ? [_vm.isTaskOperate ? _c('virtualCom', {
    style: [{
      height: _vm.iframeHeight
    }],
    attrs: {
      "index": _vm.feedIndex
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (slotProps) {
        return [_c('iframeCom', {
          key: _vm.item.unique_id,
          attrs: {
            "is-show-iframe": slotProps.visibleDom,
            "data-item": _vm.item,
            "index": _vm.feedIndex,
            "phone-info": _vm.phoneInfo,
            "is-use-cover": true
          },
          on: {
            "getIframeHeight": _vm.getIframeHeight
          }
        })];
      }
    }], null, false, 2094886845)
  }) : _c('iframeCom', {
    key: _vm.item.unique_id,
    attrs: {
      "data-item": _vm.item,
      "index": _vm.feedIndex,
      "phone-info": _vm.phoneInfo
    }
  })] : [_vm.showSwiper(_vm.item, _vm.source) ? _c('imgSwiper', {
    attrs: {
      "img-list-origin": _vm.item.body.album.content,
      "sub-source": _vm.item.shareObj.subSource,
      "tp-from": _vm.item.shareObj.tpSource,
      "source": _vm.source,
      "level-one": _vm.item.levelOne,
      "level-two": _vm.item.levelTwo,
      "note-style": "Micro",
      "unique_id": _vm.item.unique_id,
      "is-square": _vm.microPoiDetail.poi_info && !_vm.isBaiduMap && _vm.feedIndex === 0,
      "space-compress": _vm.feedIndex === 0,
      "data-index": _vm.feedIndex,
      "pre-img-height": _vm.swiperPreHeight,
      "new-btn-icon": _vm.newBtnIcon
    },
    on: {
      "swiper-bury": event => _vm.swiperBury(event, _vm.feedIndex),
      "swiper-slide-change": function ($event) {
        return _vm.swiperSlideChange(_vm.item);
      },
      "dbl-click": _vm.handleDblClick,
      "img-render": _vm.imgRender
    }
  }) : _vm._e(), _vm.item.body && _vm.item.body.overall_rating ? _c('div', {
    staticClass: "score-dv"
  }, [_c('span', {
    staticClass: "score-text"
  }, [_vm._v("评分")]), _c('star', {
    attrs: {
      "score": _vm.item.body.overall_rating
    }
  })], 1) : _vm._e(), _vm.item.body.article && _vm.item.body.article.headline ? _c('contentTitle', {
    attrs: {
      "title": _vm.item.body.article.headline
    }
  }) : _vm._e(), _vm.item.body.article.content ? _c('contentText', {
    staticClass: "content-style",
    attrs: {
      "author": _vm.item.actionBar.author,
      "poi-link": (_vm$item = _vm.item) === null || _vm$item === void 0 || (_vm$item = _vm$item.mentioned) === null || _vm$item === void 0 ? void 0 : _vm$item.merge_map_url,
      "text": _vm.item.body.article.content,
      "abtest": _vm.abtest,
      "data-index": _vm.feedIndex,
      "unique_id": _vm.item.unique_id,
      "is-push": _vm.item.tpSource === 'push',
      "phone-info": _vm.phoneInfo,
      "space-compress": _vm.feedIndex === 0
    },
    on: {
      "open-Baidu-Map": _vm.jumpToMap,
      "content-open": function ($event) {
        return _vm.contentOpen(_vm.item, _vm.feedIndex);
      }
    }
  }) : _vm._e()]], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };